<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48"
     viewBox="0 0 48 48">
  <defs>
    <circle id="a" cx="24" cy="24" r="24"/>
    <path id="b"
          d="M2.412 7.404a.957.957 0 0 0-1.356-.012.956.956 0 0 0 .009 1.353l4.014 4.014a.965.965 0 0 0 1.359.003L16.602 2.598a.952.952 0 0 0 .006-1.35.957.957 0 0 0-1.355.011L5.76 10.752 2.412 7.404z"/>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <circle cx="24" cy="24" r="23.28" stroke="#2FCD8A" stroke-width="1.44"/>
    <path d="M12.667 12.667h23.04v23.04h-23.04z"/>
    <use fill="#2FCD8A" transform="translate(15.547 17.467)" xlink:href="#b"/>
  </g>
</svg>
